module.exports = __webpack_public_path__ + "static/img/Nuvolos-transparent.a1f7a073.svg";